import { useEffect, useState } from "react";

const KEY = "nl_subscribed";

export const markSubscribed = () => {
  try {
    localStorage.setItem(KEY, "1");
    window.dispatchEvent(new Event("nl-subscribed"));
  } catch (e) { /* storage unavailable */ }
};

export const useSparkle = () => {
  const [on, setOn] = useState(() => {
    try { return !localStorage.getItem(KEY); } catch (e) { return true; }
  });
  useEffect(() => {
    const stop = () => setOn(false);
    window.addEventListener("nl-subscribed", stop);
    return () => window.removeEventListener("nl-subscribed", stop);
  }, []);
  return on;
};
